// mix-recipe-api base URL is hardcoded here per Carl's 2026-04-12T21:53Z pivot.
// The backend service lives outside the standard VITE_*_BASE_URL env set
// because it is demo-only (us-central1 Cloud Run). Swap to an env var once
// the service is promoted beyond the Mix & Apply demo.
export const MIX_RECIPE_API_HOST = 'https://mix-recipe-api-425089627817.us-central1.run.app';

export const MIX_RECIPES_API = '/api/mix-recipes';

export const JSON_HEADERS = { 'Content-Type': 'application/json' };
